module.exports = __webpack_public_path__ + "static/media/mobile_messenger.a2e57597.png";